/**
 * Init recommendations request.
 */

import 'slick-carousel';

const recommendedProducts = function () {
  const list = document.querySelector('.js-product-recommendations');
  const tabs = document.querySelector('.js-tabs');

  if (!list) {
    return;
  }

  const baseUrl = list.dataset.baseUrl;
  const productId = list.dataset.productId;
  const productLimit = list.dataset.limit;
  const productCurrency = list.dataset.currency;

  const request = new XMLHttpRequest();

  request.open(
    'GET',
    baseUrl + '.json?product_id=' + productId + '&limit=' + productLimit
  );

  request.onload = function () {
    if (request.status === 404 || request.status === 422) {
      return hideRecommendationsSection();
    }

    var products = JSON.parse(request.response).products;

    if (products.length === 0) {
      return hideRecommendationsSection();
    }

    // Append product recommendations to the DOM.
    list.innerHTML = products
      .map(function (product) {
        return renderProduct(product);
      })
      .join('');

    $('.js-product-recommendations').slick({
      slidesToShow: 2,
      slidesToScroll: 2,
      autoplay: true,
      autoplaySpeed: 4000,
      arrows: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToScroll: 3,
            slidesToShow: 3
          },
        },
        {
          breakpoint: 860,
          settings: {
            slidesToScroll: 2,
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 570,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1,
          },
        },
      ],
    });

    // Move list inside tabs.
    $('.js-section-recommended').detach().appendTo(tabs);
  };

  request.onerror = function () {
    hideRecommendationsSection();
  };

  // Send AJAX request
  request.send();

  function hideRecommendationsSection() {
    list.style.display = 'none';
  }

  function renderProduct(product) {
    return [
      `<div class="product-recommendation product-item product-item--default">
        <a href="${product.url}"><div class="product__img"><img src="${product.featured_image}" alt="${product.title}"/></div></a>
        <h4 class="product-item__title"><a href="${product.url}">${product.title}</a></h4>
        <p class="product-item__vendor">${product.vendor}</p>
        <p class="product-item__price">${Shopify.formatMoney(product.price, Shopify.current_money_format)}</p>
        </div>`
    ].join('');
  }
};

recommendedProducts();
